import { populatedSubscribeKeywordSchema } from "@redotech/redo-marketing-common/subscribe-keyword";
import * as z from "zod";

export const getSubscribeKeywords = {
  name: "getSubscribeKeywords" as const,
  input: z.object({}),
  output: z.object({ keywords: z.array(populatedSubscribeKeywordSchema) }),
};
